// extracted by mini-css-extract-plugin
export var fullHeightState = "_1k-7";
export var headerCell = "_1k-1";
export var loadingStateCell = "_1k-4";
export var rowWrapper = "_1k-3";
export var standaloneTable = "_1k-8";
export var standaloneTableWithBodyFill = "_1k-9";
export var stateCell = "_1k-5";
export var table = "_1k-0";
export var tableBodyFiller = "_1k-6";
export var white = "_1k-2";